module.exports = __webpack_public_path__ + "img/DSC_9940.28cb6e31.jpeg";